// extracted by mini-css-extract-plugin
module.exports = {"container":"CommentInput_container__WAQmV","textarea":"CommentInput_textarea__OTKgp","active":"CommentInput_active__7qUvM","btn_add_comment":"CommentInput_btn_add_comment__AygM8"};